// extracted by mini-css-extract-plugin
module.exports = {"subText":"style-module__subText___2ORU7","listTriangle":"style-module__listTriangle___1hAVr"};